import React, { useEffect, useState } from "react";
import styles from "../../Styles/modules/employeeCard.module.css";
import maleDefaultImg from "../../Styles/images/male_employee_default_img.png";
import femaleDefaultImg from "../../Styles/images/female_employee_default_img.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_GET_EMPLOYEE_FILE } from "../../config/Endpoints";
import Cookies from "js-cookie";

// ✅ Simple in-memory cache for images
const imageCache = {};

const EmployeeCard = ({ employee }) => {
  const accessToken = Cookies.get("accessToken");
  const navigate = useNavigate();

  const getDefaultImage = (gender) =>
    gender?.toLowerCase() === "female" ? femaleDefaultImg : maleDefaultImg;

  const [profileImage, setProfileImage] = useState(
    getDefaultImage(employee?.gender),
  );

  useEffect(() => {
    let isMounted = true;
    let objectUrl;

    const fetchImage = async () => {
      if (!employee?.photoPath) return;

      // Use cache if image already fetched
      if (imageCache[employee.photoPath]) {
        setProfileImage(imageCache[employee.photoPath]);
        return;
      }

      try {
        const result = employee.photoPath.split("/").slice(3).join("/");

        const res = await axios.get(API_GET_EMPLOYEE_FILE, {
          headers: { Authorization: `Bearer ${accessToken}` },
          params: { filepath: result },
          responseType: "blob",
        });

        if (res.status === 200 && isMounted) {
          objectUrl = URL.createObjectURL(res.data);
          setProfileImage(objectUrl);

          imageCache[employee.photoPath] = objectUrl;
        }
      } catch (err) {
        console.error("Error fetching image:", err);
      }
    };

    fetchImage();

    return () => {
      isMounted = false;
      // Don't revoke cached URLs to keep them reusable
      if (objectUrl && !imageCache[employee.photoPath])
        URL.revokeObjectURL(objectUrl);
    };
  }, [employee?.photoPath, accessToken]);

  const handleProfile = (e) => {
    e.preventDefault();
    navigate("/dashboard/employeeProfile", {
      state: {
        data: employee?.id,
        cachedImage: profileImage,
      },
    });
  };

  return (
    <div className={styles.employeeCard} onClick={handleProfile}>
      <span
        className={`${styles.statusTag} ${
          employee.employeeType === "REGULAR" ? styles.regular : styles.contract
        }`}
      >
        {employee.employeeType}
      </span>

      <div className={styles.profileImageWrapper}>
        <img
          src={profileImage}
          alt={employee.firstName}
          className={styles.profileImg}
        />
      </div>

      <div className={styles.employeeInfo}>
        <h3 className={styles.empName}>{employee.empName}</h3>
        <p className={styles.empDesignation}>{employee.designation}</p>
        <span className={styles.empDepartment}>{employee.department}</span>
      </div>
    </div>
  );
};

export default EmployeeCard;
